import { render, staticRenderFns } from "./EvolutionChart.vue?vue&type=template&id=2c39f97e&scoped=true&"
import script from "./EvolutionChart.vue?vue&type=script&lang=js&"
export * from "./EvolutionChart.vue?vue&type=script&lang=js&"
import style0 from "./EvolutionChart.vue?vue&type=style&index=0&id=2c39f97e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39f97e",
  null
  
)

/* custom blocks */
import block0 from "./EvolutionChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports